module.exports = __webpack_public_path__ + "static/media/img-drop-header.74bd4d2a.jpg";